import { useRemoveSharePointResourceByFolderMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleSuccessNotification } from 'hooks/notificationHandler'
import { Step } from '../SteppedModal/types'
import { AdvancedCreateModalProps } from './types'
import ExternalLinkEditor from '../../ExternalLinkEditor'
import SharePointUploader from '../../SharePointUploader'
import { useEffect, useState } from 'react'
import SteppedModal from '../SteppedModal'
import { useProjectContext } from 'context/ProjectContext'

const AdvancedCreateModal: React.VFC<AdvancedCreateModalProps> = ({
  details,
  additionalInfo,
  attachments,
  ...rest
}) => {
  const { projectId } = useProjectContext()
  const [remove] = useRemoveSharePointResourceByFolderMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({ removeSharePointResource: { message, removed } }) => {
      if (removed) simpleSuccessNotification(message)
    },
  })
  const [steps, setSteps] = useState<Step[]>([])
  useEffect(() => {
    setSteps([
      {
        title: 'Details',
        component: (store) =>
          typeof details === 'function' ? details(store) : details,
      },
      {
        title: 'Additional Info',
        component: (store) =>
          typeof additionalInfo === 'function'
            ? additionalInfo(store)
            : additionalInfo,
      },
    ])
    if (!attachments) return
    setSteps((prev) => [
      ...prev.filter(({ title }) => title !== 'Attachments'),
      {
        title: 'Attachments',
        component: (store) => {
          const folder = attachments.sharePoint
            ? attachments.sharePoint.folder(store)
            : undefined
          return (
            <>
              {!!attachments.sharePoint && folder && (
                <SharePointUploader
                  showHyperlinkWarning
                  {...attachments.sharePoint}
                  folder={folder}
                />
              )}
              {!!attachments.externalLinks && (
                <ExternalLinkEditor
                  quickLinkOptions={attachments.externalLinks}
                  messages={{ sharePoint: true }}
                />
              )}
              {attachments.children}
            </>
          )
        },
      },
    ])
  }, [additionalInfo, attachments, details])
  return (
    <SteppedModal
      {...rest}
      steps={steps}
      cleanUp={async (store) => {
        if (!Object.keys(store ?? {}).length) return
        if (!attachments || !attachments.sharePoint) return
        const { parent, skipCleanup = false } = attachments.sharePoint
        if (skipCleanup) return
        const folder = attachments.sharePoint.folder(store)
        if (!folder) return
        remove({
          variables: {
            removeSharePointResourceInput: {
              projectId,
              byFolder: { folder, parentId: parent.id },
            },
          },
        })
      }}
    />
  )
}

export default AdvancedCreateModal
